interface PageSEOProps {
  title: string;
  description: string;
  canonical: string;
  schema?: object | object[];
}

export default function PageSEO({ title, description, canonical, schema }: PageSEOProps) {
  const siteUrl = (import.meta.env.VITE_SITE_URL ?? '').replace(/\/$/, '');
  const canonicalUrl = `${siteUrl}${canonical}`;

  const schemas = schema
    ? Array.isArray(schema)
      ? schema
      : [schema]
    : [];

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {schemas.map((s, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(s)}
        </script>
      ))}
    </>
  );
}
